import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import creditCardImage from '../../../../public/static/books/credit-card.png';
import BooksOutlineLabel from '../common/labels/BooksOutlineLabel';

import css from './BooksLabeledContainer.module.scss';

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  contentsPadding?: boolean;
  creditCardLabel?: boolean;
  description?: string;
  errorStyle?: boolean;
  label: string;
  paddingTop?: boolean;
  requiredLabel?: boolean;
  noBorderBottom?: boolean;
}

const BooksLabeledContainer = ({
  className,
  children,
  contentsPadding,
  creditCardLabel,
  description,
  errorStyle,
  intl,
  label,
  paddingTop,
  requiredLabel,
  noBorderBottom,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksLabeledContainer, className);
  const labelclasses = classNames(css.BooksLabeledContainer__Label, {
    [css.isCreditCard]: creditCardLabel,
    [css.isRequired]: requiredLabel,
    [css.withPaddingTop]: paddingTop,
  });
  const contentsClasses = classNames(css.BooksLabeledContainer__Contents, {
    [css.withContentsPadding]: contentsPadding,
    [css.isError]: errorStyle,
    [css.noBorderBottom]: noBorderBottom,
  });

  return (
    <div className={classes}>
      <div className={labelclasses}>
        <div className={css.BooksLabeledContainer__LabelInner}>
          {label}
          {requiredLabel && (
            <BooksOutlineLabel
              className={css.BooksLabeledContainer__Required}
              label={intl.formatMessage({
                id: 'books.required',
              })}
            />
          )}
          {creditCardLabel && (
            <img
              className={css.BooksLabeledContainer__CreditCard}
              src={creditCardImage}
              alt="VISA, Mastercard, American Express"
            />
          )}
        </div>
        {description && (
          <span className={css.BooksLabeledContainer__Description}>
            {description}
          </span>
        )}
      </div>
      <div className={contentsClasses}>{children}</div>
    </div>
  );
};

export default injectIntl(BooksLabeledContainer);
